module.exports = __webpack_public_path__ + "static/media/terreno_piscina.06d30e8c.svg";